import { backend } from "@/backend";

export const storeClassificationsMiddleware = async (to, from, next) => {
    try {
        const response = await backend.get('classifications')
        localStorage.setItem('classifications', JSON.stringify(response.data.body));
    } catch (error) {
        next()
        return;
    }

    next();
}